import React, { createContext, useState, useContext } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        show: false,
        message: '',
        type: 'info'
    });

    const showToast = (message, type = 'info') => {
        setToast({ show: true, message, type });
        
        setTimeout(() => {
            setToast({ show: false, message: '', type: 'info' });
        }, 5000);
    };

    const hideToast = () => {
        setToast({ show: false, message: '', type: 'info' });
    };

    return (
        <ToastContext.Provider value={{ toast, showToast, hideToast }}>
            {children}
        </ToastContext.Provider>
    );
};
